<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf s_ptb0lr24">
      <a-tabs v-model:activeKey="activeKey">
    
        <!-- <a-tab-pane key="2" tab="清零记录">
          <zeroHistory></zeroHistory>
        </a-tab-pane> -->
        <a-tab-pane key="3" tab="积分设置">
          <integralSet :dataMore='dataMore'></integralSet>
        </a-tab-pane>
           <a-tab-pane key="4" tab="积分说明设置">
          <description :dataMore='dataMore'></description>
        </a-tab-pane>
            <a-tab-pane key="1" tab="清零设置">
          <zeroSet :dataMore='dataMore'></zeroSet>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-layout>
</template>
<script>
  import { ref,inject } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import zeroSet from './components/zeroSet';
  // import zeroHistory from './components/zeroHistory';
  import integralSet from './components/integralSet';
  import description from './components/description';
  // 初始化默认筛选项数值
  let defForm = {
    resource:null
  }
  export default {
    components: {  integralSet,description,zeroSet },
    setup(props) {
    const $route = inject('$route')
      return {
        activeKey: ref($route.query.active || '3')
      };
    },
  };
</script>